export const GET_ALL_TESTIMONIALS = 'GET_ALL_TESTIMONIALS';


